// Mode'a gore secim UI'si — YATAY tek satir bar (DataTable filter bar
// mantigi). Sol tarafta baslik, sagda SelectField tum genisligi doldurur.
// Sticky sidebar patterni kaldirildi.

import { Card, CardContent, Box, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import SelectField from '../../../components/FormField/SelectField';

const SelectorPanel = ({
  mode,
  teams = [], allUsers = [],
  selectedTeamIds, setSelectedTeamIds,
  selectedTeamId, setSelectedTeamId,
  selectedUserIds, setSelectedUserIds,
}) => {
  const teamOptions = teams.map(t => ({
    value: t.id,
    label: t.users_aggregate?.aggregate?.count != null
      ? `${t.name} · ${t.users_aggregate.aggregate.count} kişi`
      : t.name,
  }));
  const userOptions = allUsers.map(u => {
    const fullName = `${u.first_name || ''} ${u.last_name || ''}`.trim() || `#${u.id}`;
    return {
      value: u.id,
      label: u.team?.name ? `${fullName} · ${u.team.name}` : fullName,
    };
  });

  const renderInput = () => {
    if (mode === 'teams') {
      return (
        <SelectField
          field={{
            name: 'teams',
            label: 'Ekip Seç',
            type: 'multiselect',
            options: teamOptions,
          }}
          value={selectedTeamIds}
          onChange={(_name, val) => setSelectedTeamIds(val || [])}
        />
      );
    }
    if (mode === 'members') {
      return (
        <SelectField
          field={{
            name: 'team',
            label: 'Ekip Seç',
            type: 'autocomplete',
            options: teamOptions,
          }}
          value={selectedTeamId}
          onChange={(_name, val) => setSelectedTeamId(val ?? null)}
        />
      );
    }
    if (mode === 'people') {
      return (
        <SelectField
          field={{
            name: 'users',
            label: 'Kişi Seç',
            type: 'multiselect',
            options: userOptions,
          }}
          value={selectedUserIds}
          onChange={(_name, val) => setSelectedUserIds(val || [])}
        />
      );
    }
    return null;
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '16px',
        background: '#ffffff',
        border: '1px solid #e8eaee',
        boxShadow: '0 1px 2px rgba(20,30,55,.04)',
      }}
    >
      <CardContent sx={{
        p: '16px !important',
        '&:last-child': { pb: '16px !important' },
        display: 'flex', alignItems: 'center', gap: 2,
        flexWrap: { xs: 'wrap', md: 'nowrap' },
      }}>
        {/* Sol: baslik */}
        <Box sx={{
          display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0,
        }}>
          <Box sx={{
            width: 30, height: 30, borderRadius: '10px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'linear-gradient(135deg, rgba(58,90,240,0.12), rgba(58,90,240,0.04))',
            border: '1px solid rgba(58,90,240,0.12)',
            color: '#3a5af0',
          }}>
            <FilterListIcon sx={{ fontSize: '1rem' }} />
          </Box>
          <Typography sx={{
            fontSize: '13px', fontWeight: 700, color: '#0f1424', letterSpacing: '-0.1px',
          }}>
            Filtre
          </Typography>
        </Box>

        {/* Sag: input tum genisligi doldurur */}
        <Box sx={{ flex: 1, minWidth: { xs: '100%', md: 0 } }}>
          {renderInput()}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SelectorPanel;
